import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import Button from '@ui/buttons/Button'

interface Props {
  open: boolean
  onClose: () => void
  onUseEmail: () => void
  onUseMobile: () => void
}

export default function MultipleAccountsFoundModal({
  open,
  onClose,
  onUseEmail,
  onUseMobile,
}: Props) {
  const { t } = useTranslation(['modals'])

  return (
    <ModalBottom
      open={open}
      close={onClose}
      title={t('modals:multipleAccountsFound.title')}
      desc={t('modals:multipleAccountsFound.desc')}
      spacedText
      body={
        <View className="flex-row items-center gap-8 px-16">
          <Button
            variant="outlined"
            label={t('modals:multipleAccountsFound.useEmail')}
            onPress={onUseEmail}
          />
          <Button
            variant="outlined"
            label={t('modals:multipleAccountsFound.useMobile')}
            onPress={onUseMobile}
          />
        </View>
      }
    />
  )
}
